import { ModalContent } from 'components/ui/Modal';
import React from 'react';
import { Alert, Button, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

interface ICommentVisibilityModalProps {
  title: string
  label: string
  resetInputs: boolean
  cancelModal: () => void
  submitModal: (reason: string, callback: () => void) => void
}

interface ICommentVisibilityModalState {
  reason: string
  error: string
}

export class CommentVisibilityModal extends React.Component<ICommentVisibilityModalProps, ICommentVisibilityModalState> {

  public state: ICommentVisibilityModalState = {
    reason: '',
    error: '',
  }

  submitForm(e) {
    const { reason } = this.state
    const { submitModal } = this.props

    e.preventDefault()

    if (reason && reason !== '') {
      if (submitModal) {
        submitModal(reason, () => this.setState({ reason: '', error: '' }))
      }
    } else {
      this.setState({ error: 'Reason cannot be empty.' })
    }
  }

  onCancel() {
    const { cancelModal } = this.props

    this.setState({ reason: '', error: '' })
    if (cancelModal) {
      cancelModal()
    }
  }

  render() {
    const { reason, error } = this.state
    const modalHeaderStyle = { padding: '10px' }

    return (
      <section className="blacklight">
        <Form onSubmit={(e) => this.submitForm(e)}>
          <ModalHeader style={modalHeaderStyle}>
            {this.props.title}
          </ModalHeader>
          <ModalContent>
            {error !== '' &&
              <Alert color="warning">
                {error}
              </Alert>
            }
            <p>
              <Label>{this.props.label}:</Label>
              <Input type="textarea" value={reason} onChange={(e) => this.setState({ reason: e.currentTarget.value })} />
            </p>
          </ModalContent>
          <ModalFooter>
            <Button color="white" onClick={() => this.onCancel()}>
              <span>Cancel</span>
            </Button>
            <Button type="submit" color="danger">
              <span>Save</span>
            </Button>
          </ModalFooter>
        </Form>
      </section>
    )
  }
}
